import { researchTypes } from '../../globals.js';

// The localization terms of an instant research item are named after its sku, with the letter after
// the category lower-cased: instantResearchInfantryTier4 → instantResearchinfantryTier4Title. For all
// but one item that also spells the name of the research it unlocks, which is the only thing the game
// builds the key from; item 2501 (sku instantResearchInfantryTier4) unlocks royalGuard. Items that
// carry no sku (event prizes are just { id, amount }) only have the research name to go on.
// Returns the term bases to try, best first.
export function instantResearchTermBases(item, gameItem) {
    const byResearch = gameItem.category + researchTypes[gameItem.type];
    const sku = item?.sku;
    if (typeof sku !== 'string' || !sku.startsWith(gameItem.category) || sku.length === gameItem.category.length) {
        return [byResearch];
    }
    const rest = sku.slice(gameItem.category.length);
    const bySku = gameItem.category + rest.charAt(0).toLowerCase() + rest.slice(1);
    return bySku === byResearch ? [bySku] : [bySku, byResearch];
}
